import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import "./additions.css";
import App from "./App";

const rootElement = document.getElementById("root");

if (rootElement) {
  const app = (
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  );
  // The prerendered markup is for crawlers and first paint. The page has animated and
  // scroll-driven parts that differ between server and browser, so the app renders fresh
  // instead of hydrating.
  ReactDOM.createRoot(rootElement).render(app);
}
